import { render, staticRenderFns } from "./LiveBroadcastDetail.vue?vue&type=template&id=0215e646&scoped=true"
import script from "./LiveBroadcastDetail.vue?vue&type=script&lang=js"
export * from "./LiveBroadcastDetail.vue?vue&type=script&lang=js"
import style0 from "./LiveBroadcastDetail.vue?vue&type=style&index=0&id=0215e646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0215e646",
  null
  
)

export default component.exports